import {
  TBooleanState,
} from '../../utils/boolean.ts';

const tooltip: Record<TBooleanState, string> = {
  nullish: 'Wszystkie',
  true: 'Prawda',
  false: 'Fałsz',
};

export default tooltip;
